import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { filter, map, tap, withLatestFrom } from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import {RouterActions} from '@emm/core/store/router.actions';
import {RouterStoreService} from '@emm/core/store/router-store.service';

@Injectable({
    providedIn: 'root'
})
export class RouterStoreEffects {

    go$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RouterActions.go),
                tap(({ path, query: queryParams, extras }) => {
                    this.router.navigate(path, { queryParams, ...extras });
                })
            ),
        { dispatch: false }
    );

    navigateSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(routerNavigatedAction),
                withLatestFrom(this.store.selectRouteData()),
                map(R.last),
                filter(RA.isNotNilOrEmpty),
                map(title => title),
                map(R.ifElse(RA.isNilOrEmpty, R.always('EMM - Menu Data Management'), R.identity))
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private router: Router,
        private store: RouterStoreService
    ) {}
}
